<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      v-on:table-clone-request="clone"
      :showEdit="true"
      :showClone="true"
      :showDelete="true"
      :tableData="tableData"
      :tableTitle="'Spreadsheet Descriptors'"
      :fields="fields"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    >
    </vuetable>
  </section>
</template>
<script>
import vuetable from '../../../helpers/VueTable.vue'
import Loader from '../../../helpers/Loader.vue'
import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
import API from '../../../../api/endpoints'
import event from '../../../../event'
export default {
  name: 'SpreadsheetDescriptorSearchResults',
  components: {
    vuetable: vuetable,
    Loader
  },
  mixins: [ AdminSearchResults ],
  data () {
    return {
      fields: [
        { header: 'Name', prop: 'name' },
        { header: 'Parent', prop: item => item.parent !== null ? item.parent.name : '', hideByDefault: true },
        { header: 'Entity Type', prop: item => item.entityType !== null ? item.entityType.name : '' },
        { header: 'Property', prop: 'property', hideByDefault: true },
        { header: 'Data Type', prop: item => item.dataType !== null ? item.dataType.name : '', hideByDefault: true },
        { header: 'Actual Value', prop: 'actualValue', hideByDefault: true }
      ],
      loading: false,
      tableData: [],
      entityName: 'spreadsheet-descriptor',
      editEntityScreen: 'Admin - Edit/View Spreadsheet Descriptor'
    }
  },
  methods: {
    clone ({item}) {
      this.$http.post(API.SPREADSHEET_CLONE(item.id), {})
        .then(({data}) => {
          event.$emit('toast', { message: 'Clone successful', type: 'success' })
          this.getResults()
        }).catch(err => {
          console.log(err)
          event.$emit('toast', { message: 'Clone failed', type: 'error' })
        })
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// SpreadsheetDescriptorSearchResults.vue?054893a0